export default {"src":"/_next/static/media/frame3.7410da0b.svg","height":110,"width":233,"blurWidth":0,"blurHeight":0};